import { ApolloProvider } from "@apollo/client";
import { Layer } from "@carbon/react";
import {
  AuthModeProvider,
  DashboardListPanel,
  InternationalizationProvider as ReportingInternationalizationProvider,
  ReportingAuthGuard,
} from "@flaminem/reporting-admin";
import { useNavigate } from "react-router-dom";

import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { getReportingApolloClient } from "src/graphql/reporting/apolloClient";
import { useLocale, useT } from "src/internationalization";

export const DashboardListPanelDisplay = () => {
  const navigate = useNavigate();
  const { locale } = useLocale();
  const t = useT();

  return (
    <ApolloProvider client={getReportingApolloClient()}>
      <AuthModeProvider authMode="bearer">
        <ReportingAuthGuard>
          <ReportingInternationalizationProvider locale={locale}>
            <PageStack>
              <PageHeader className="mb-5">{t("page.reporting.title")}</PageHeader>
              <Layer level={1}>
                <DashboardListPanel
                  onClick={(dashboardId) => navigate(`/reporting/${dashboardId}`)}
                />
              </Layer>
            </PageStack>
          </ReportingInternationalizationProvider>
        </ReportingAuthGuard>
      </AuthModeProvider>
    </ApolloProvider>
  );
};
